'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _hubMap;

var _Hubs = require('self-service-api/constants/Hubs');

var Hubs = _interopRequireWildcard(_Hubs);

var _MerchandiseIds = require('self-service-api/constants/MerchandiseIds');

var MerchandiseIds = _interopRequireWildcard(_MerchandiseIds);

var _ObjectDefaults = require('self-service-api/constants/ObjectDefaults');

var _Features = require('self-service-api/constants/Features');

var _Features2 = _interopRequireDefault(_Features);

var _PurchaseTypes = require('self-service-api/constants/PurchaseTypes');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var hubMap = (_hubMap = {}, _defineProperty(_hubMap, Hubs.CMS, {
  merchandise: [MerchandiseIds.ADDON_CMS],
  highlightedPaidMerch: [MerchandiseIds.ADDON_CMS],
  highlightedFreeMerch: null,
  hubSpecificFeatures: [_Features2.default.ALL_CRM_FEATURES],
  merchPurchaseType: null
}), _defineProperty(_hubMap, Hubs.HUB_MARKETING, {
  merchandise: [MerchandiseIds.PRODUCT_MARKETING_FREE, MerchandiseIds.PRODUCT_MARKETING_STARTER, MerchandiseIds.PRODUCT_MARKETING_STARTER_EMAIL, MerchandiseIds.PRODUCT_MARKETING_STARTER_CONTACTS, MerchandiseIds.PRODUCT_MARKETING_BASIC, MerchandiseIds.PRODUCT_MARKETING_BASIC_CONTACTS, MerchandiseIds.PRODUCT_MARKETING_PROFESSIONAL, MerchandiseIds.PRODUCT_MARKETING_PROFESSIONAL_CONTACTS, MerchandiseIds.PRODUCT_MARKETING_ENTERPRISE, MerchandiseIds.PRODUCT_MARKETING_ENTERPRISE_CONTACTS],
  highlightedPaidMerch: [MerchandiseIds.PRODUCT_MARKETING_STARTER_EMAIL, MerchandiseIds.PRODUCT_MARKETING_PROFESSIONAL, MerchandiseIds.PRODUCT_MARKETING_ENTERPRISE],
  highlightedFreeMerch: MerchandiseIds.PRODUCT_MARKETING_FREE,
  hubSpecificFeatures: [_Features2.default.LIVE_CHAT, _Features2.default.CONVERSATIONAL_BOTS, _Features2.default.NATIVE_FORMS, _Features2.default.REPORTING_DASHBOARDS, _Features2.default.TEAMS, _Features2.default.PHONE_SUPPORT, _Features2.default.ALL_CRM_FEATURES, _Features2.default.CUSTOM_REPORTS, _Features2.default.CALCULATED_PROPERTIES],
  merchPurchaseType: _PurchaseTypes.CONTACT_BASED
}), _defineProperty(_hubMap, Hubs.HUB_SALES, {
  merchandise: [MerchandiseIds.PRODUCT_SALES_FREE, MerchandiseIds.PRODUCT_SALES_PRO_LEGACY, MerchandiseIds.PRODUCT_SALES_STARTER, MerchandiseIds.PRODUCT_SALES_PROFESSIONAL, MerchandiseIds.PRODUCT_SALES_PROFESSIONAL_ADDITIONAL_USER, MerchandiseIds.PRODUCT_SALES_ENTERPRISE, MerchandiseIds.PRODUCT_SALES_ENTERPRISE_ADDITIONAL_USER],
  highlightedPaidMerch: [MerchandiseIds.PRODUCT_SALES_STARTER, MerchandiseIds.PRODUCT_SALES_PROFESSIONAL, MerchandiseIds.PRODUCT_SALES_ENTERPRISE],
  highlightedFreeMerch: MerchandiseIds.PRODUCT_SALES_FREE,
  hubSpecificFeatures: [_Features2.default.LIVE_CHAT, _Features2.default.CONVERSATIONAL_BOTS, _Features2.default.REPORTING_DASHBOARDS, _Features2.default.TEAMS, _Features2.default.PHONE_SUPPORT, _Features2.default.ALL_CRM_FEATURES, _Features2.default.CUSTOM_REPORTS, _Features2.default.SEQUENCE_QUEUES, _Features2.default.GOALS, _Features2.default.PLAYBOOKS, _Features2.default.TEMPLATES, _Features2.default.DOCUMENTS, _Features2.default.CALCULATED_PROPERTIES, _Features2.default.EMAIL_SCHEDULING, _Features2.default.SEQUENCES, _Features2.default.CONVERSATION_ROUTING],
  merchPurchaseType: _PurchaseTypes.SEAT_BASED
}), _defineProperty(_hubMap, Hubs.HUB_SERVICE, {
  merchandise: [MerchandiseIds.PRODUCT_SERVICE_FREE, MerchandiseIds.PRODUCT_SERVICE_STARTER, MerchandiseIds.PRODUCT_SERVICE_PROFESSIONAL, MerchandiseIds.PRODUCT_SERVICE_PROFESSIONAL_ADDITIONAL_USER, MerchandiseIds.PRODUCT_SERVICE_ENTERPRISE, MerchandiseIds.PRODUCT_SERVICE_ENTERPRISE_ADDITIONAL_USER],
  highlightedPaidMerch: [MerchandiseIds.PRODUCT_SERVICE_STARTER, MerchandiseIds.PRODUCT_SERVICE_PROFESSIONAL, MerchandiseIds.PRODUCT_SERVICE_ENTERPRISE],
  highlightedFreeMerch: MerchandiseIds.PRODUCT_SERVICE_FREE,
  hubSpecificFeatures: [_Features2.default.LIVE_CHAT, _Features2.default.CONVERSATIONAL_BOTS, _Features2.default.CONVERSATIONS_INBOX, _Features2.default.TEAMS, _Features2.default.PHONE_SUPPORT, _Features2.default.ALL_CRM_FEATURES, _Features2.default.CUSTOM_REPORTS, _Features2.default.SEQUENCE_QUEUES, _Features2.default.GOALS, _Features2.default.PLAYBOOKS, _Features2.default.CALCULATED_PROPERTIES, _Features2.default.EMAIL_SCHEDULING, _Features2.default.SEQUENCES, _Features2.default.CONVERSATION_ROUTING],
  merchPurchaseType: _PurchaseTypes.SEAT_BASED
}), _hubMap);

var exportedHubMap = {};

// Add defaults. Defaults overridden by hubMap
// if specified
Object.keys(hubMap).forEach(function (hubKey) {
  exportedHubMap[hubKey] = _extends({}, _ObjectDefaults.HubObjectDefault, hubMap[hubKey]);
});

exports.default = exportedHubMap;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/self-service-api/static-1.837/js/constants/HubMap.js
// module id = 68
// module chunks = 3 4 5